module.exports = __webpack_public_path__ + "static/couture01-933df68bb61f8fb8140cfe4f0809b61a.png";